import { withStyles } from '@material-ui/core';
import TextField from './component/TextField';
import MoneyField from './component/MoneyField';
import withFormControl from '../withFormControl';
import withFilled from './component/withFilled';
import SimpleTextField from './component/SimpleTextField';

const style = theme => ({
    formHelperText: {
        marginTop: 0,
    },
    disclaimer: {
        color: theme.palette.grey[800],
    },
});

const StyledTextField = withStyles(style)(TextField);
const StyledMoneyField = withStyles(style)(MoneyField);

export default StyledTextField;

export const MoneyFieldWithFilledFormControl = withFormControl(withFilled(StyledMoneyField));
export const MoneyFieldFormControl = withFormControl(StyledMoneyField);
export const TextFieldFormControl = withFormControl(StyledTextField);
export const SimpleTextFieldFormControl = withFormControl(SimpleTextField);

export { SimpleTextField };
